export default __webpack_public_path__ + "static/media/average_breakfast.5ec6557f.png";